/** Validation message keys for use with i18next `t()`. */

export type CredentialsField = 'name' | 'email' | 'password';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateEmail = (value: string): string | null => {
  const trimmed = value.trim();
  if (!trimmed) {
    return 'validation.emailRequired';
  }
  if (!EMAIL_PATTERN.test(trimmed)) {
    return 'validation.emailInvalid';
  }
  return null;
};

export const validateName = (value: string): string | null => {
  const trimmed = value.trim();
  if (!trimmed) {
    return 'validation.nameRequired';
  }
  if (trimmed.length < 2) {
    return 'validation.nameTooShort';
  }
  return null;
};

export const validateLoginPassword = (value: string): string | null => {
  if (!value) {
    return 'validation.passwordRequired';
  }
  return null;
};

export const validateRegisterPassword = (value: string): string | null => {
  if (!value) {
    return 'validation.passwordRequired';
  }
  if (value.length < 8) {
    return 'validation.passwordTooShort';
  }
  return null;
};

export const validatePasswordConfirmation = (
  password: string,
  confirmation: string,
): string | null => {
  if (!confirmation) {
    return 'validation.passwordRequired';
  }
  if (password !== confirmation) {
    return 'validation.passwordMismatch';
  }
  return null;
};

export const validateMfaCode = (value: string): string | null => {
  if (!value) {
    return 'validation.mfaRequired';
  }
  if (!/^\d{6}$/.test(value)) {
    return 'validation.mfaInvalid';
  }
  return null;
};

export const validateCredentials = (
  mode: 'login' | 'register',
  values: { name: string; email: string; password: string },
): Partial<Record<CredentialsField, string>> => {
  const errors: Partial<Record<CredentialsField, string>> = {};

  const emailError = validateEmail(values.email);
  if (emailError) {
    errors.email = emailError;
  }

  const passwordError =
    mode === 'register'
      ? validateRegisterPassword(values.password)
      : validateLoginPassword(values.password);
  if (passwordError) {
    errors.password = passwordError;
  }

  if (mode === 'register') {
    const nameError = validateName(values.name);
    if (nameError) {
      errors.name = nameError;
    }
  }

  return errors;
};
